import React from 'react';

// Премиальные SVG иконки для статусов

interface IconProps {
  size?: number;
}

// Цвета для 10 VIP уровней (соответствуют админке)
const getVipColor = (level: number): string => {
  const colors = [
    '#9CA3AF',  // 1: Starter - серый
    '#CD7F32',  // 2: Bronze - бронзовый
    '#A78BFA',  // 3: Warrior - фиолетовый
    '#C0C0C0',  // 4: Silver - серебряный
    '#60A5FA',  // 5: Elite - синий
    '#FFD700',  // 6: Gold - золотой
    '#F59E0B',  // 7: Diamond - оранжевый
    '#E5E4E2',  // 8: Platinum - платиновый
    '#C084FC',  // 9: Royal - королевский фиолетовый
    '#8B5CF6'   // 10: Cosmic - космический фиолетовый
  ];
  return colors[level - 1] || '#6366f1';
};

// Универсальная VIP иконка для всех уровней
interface VIPIconProps extends IconProps {
  level: number;
}

export const VIPIcon: React.FC<VIPIconProps> = ({ level, size = 64 }) => {
  const color = getVipColor(level);
  const gradientId = `vip-gradient-${level}`;

  // Вычисляем более темный оттенок для градиента
  const darkerColor = color.replace(/[0-9A-F]{2}$/i, (match) => {
    const value = Math.max(0, parseInt(match, 16) - 40);
    return value.toString(16).padStart(2, '0');
  });

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id={gradientId} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{ stopColor: color, stopOpacity: 1 }} />
          <stop offset="100%" style={{ stopColor: darkerColor, stopOpacity: 1 }} />
        </linearGradient>
      </defs>
      <circle cx="32" cy="32" r="28" fill={`url(#${gradientId})`} stroke={darkerColor} strokeWidth="2"/>
      <circle cx="32" cy="32" r="24" fill="none" stroke="#FFFFFF" strokeWidth="1" opacity="0.3"/>
      <text x="32" y="40" fontFamily="Arial, sans-serif" fontSize="28" fontWeight="bold" fill="#FFFFFF" textAnchor="middle">
        V
      </text>
    </svg>
  );
};

// Оставляем старые иконки для обратной совместимости (deprecated)
export const BronzeVIPIcon: React.FC<IconProps> = ({ size = 64 }) => <VIPIcon level={2} size={size} />;
export const SilverVIPIcon: React.FC<IconProps> = ({ size = 64 }) => <VIPIcon level={4} size={size} />;
export const GoldVIPIcon: React.FC<IconProps> = ({ size = 64 }) => <VIPIcon level={6} size={size} />;
export const PlatinumVIPIcon: React.FC<IconProps> = ({ size = 64 }) => <VIPIcon level={8} size={size} />;

// Ранги
export const NoviceRankIcon: React.FC<IconProps> = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="novice-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#90EE90', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#228B22', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <path d="M32 8 L40 28 L60 32 L40 36 L32 56 L24 36 L4 32 L24 28 Z" fill="url(#novice-gradient)" stroke="#006400" strokeWidth="2"/>
    <circle cx="32" cy="32" r="8" fill="#FFFFFF" opacity="0.3"/>
  </svg>
);

export const BronzeRankIcon: React.FC<IconProps> = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="bronze-rank-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#CD7F32', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#8B4513', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <path d="M32 4 L40 22 L60 28 L44 44 L48 62 L32 52 L16 62 L20 44 L4 28 L24 22 Z" fill="url(#bronze-rank-gradient)" stroke="#5D3A1A" strokeWidth="2"/>
    <circle cx="32" cy="32" r="10" fill="#FFFFFF" opacity="0.2"/>
    <text x="32" y="38" fontFamily="Arial, sans-serif" fontSize="18" fontWeight="bold" fill="#FFFFFF" textAnchor="middle">
      III
    </text>
  </svg>
);

export const SilverRankIcon: React.FC<IconProps> = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="silver-rank-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#E8E8E8', stopOpacity: 1 }} />
        <stop offset="50%" style={{ stopColor: '#C0C0C0', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#A8A8A8', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <path d="M32 4 L40 22 L60 28 L44 44 L48 62 L32 52 L16 62 L20 44 L4 28 L24 22 Z" fill="url(#silver-rank-gradient)" stroke="#808080" strokeWidth="2"/>
    <circle cx="32" cy="32" r="10" fill="#FFFFFF" opacity="0.3"/>
    <text x="32" y="38" fontFamily="Arial, sans-serif" fontSize="18" fontWeight="bold" fill="#4A4A4A" textAnchor="middle">
      II
    </text>
  </svg>
);

export const GoldRankIcon: React.FC<IconProps> = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="gold-rank-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#FFD700', stopOpacity: 1 }} />
        <stop offset="50%" style={{ stopColor: '#FFA500', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#FF8C00', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <path d="M32 4 L40 22 L60 28 L44 44 L48 62 L32 52 L16 62 L20 44 L4 28 L24 22 Z" fill="url(#gold-rank-gradient)" stroke="#B8860B" strokeWidth="2"/>
    <circle cx="32" cy="32" r="10" fill="#FFEC8B" opacity="0.4"/>
    <text x="32" y="38" fontFamily="Arial, sans-serif" fontSize="18" fontWeight="bold" fill="#8B4500" textAnchor="middle">
      I
    </text>
  </svg>
);

// Лидерские статусы - Иконки пользователей
export const BronzeLeaderIcon: React.FC<IconProps> = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="bronze-leader-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#CD7F32', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#8B4513', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="url(#bronze-leader-gradient)"/>
  </svg>
);

export const SilverLeaderIcon: React.FC<IconProps> = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="silver-leader-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#E8E8E8', stopOpacity: 1 }} />
        <stop offset="50%" style={{ stopColor: '#C0C0C0', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#A0A0A0', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="url(#silver-leader-gradient)"/>
  </svg>
);

export const GoldLeaderIcon: React.FC<IconProps> = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="gold-leader-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#FFD700', stopOpacity: 1 }} />
        <stop offset="50%" style={{ stopColor: '#FFA500', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#FF8C00', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="url(#gold-leader-gradient)"/>
  </svg>
);

export const PlatinumLeaderIcon: React.FC<IconProps> = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="platinum-leader-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#E5E4E2', stopOpacity: 1 }} />
        <stop offset="50%" style={{ stopColor: '#BCC6CC', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#98A4AE', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="url(#platinum-leader-gradient)"/>
  </svg>
);

export const DiamondLeaderIcon: React.FC<IconProps> = ({ size = 64 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="diamond-leader-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" style={{ stopColor: '#B9F2FF', stopOpacity: 1 }} />
        <stop offset="50%" style={{ stopColor: '#00CED1', stopOpacity: 1 }} />
        <stop offset="100%" style={{ stopColor: '#0099CC', stopOpacity: 1 }} />
      </linearGradient>
    </defs>
    <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" fill="url(#diamond-leader-gradient)"/>
  </svg>
);

// Функция для получения иконки по типу и уровню
export const getStatusIcon = (type: 'vip' | 'rank' | 'leader', level: number, size: number = 64) => {
  if (type === 'vip') {
    // Поддержка всех 10 VIP уровней
    return <VIPIcon level={level} size={size} />;
  }

  if (type === 'rank') {
    if (level === 0) return <NoviceRankIcon size={size} />;
    if (level <= 5) return <BronzeRankIcon size={size} />;
    if (level <= 10) return <SilverRankIcon size={size} />;
    return <GoldRankIcon size={size} />;
  }

  if (type === 'leader') {
    if (level === 1) return <BronzeLeaderIcon size={size} />;
    if (level === 2) return <SilverLeaderIcon size={size} />;
    if (level === 3) return <GoldLeaderIcon size={size} />;
    if (level === 4) return <PlatinumLeaderIcon size={size} />;
    if (level === 5) return <DiamondLeaderIcon size={size} />;
    return <BronzeLeaderIcon size={size} />;
  }

  return null;
};
